export default {
  // Document settings
  advisoryOpinionFieldsForHide: state => state.advisoryOpinionFieldsForHide,
  // Patient reception schedule settings
  getPatientReceptionScheduleSettings: state => state.patientReceptionScheduleSettings,
  // Cash register settings
  getCashRegisterSettings: state => state.cashRegisterSettings,
  // Price settings
  getPriceSettings: state => state.priceSettings,
  // Treatment diary settings
  getTreatmentDiarySettings: state => state.treatmentDiarySettings,
  treatmentDiarySortTypeOptions: state => state.treatmentDiarySortTypeOptions,
  // Employee settings
  getEmployeeSettings: state => state.employeeSettings,
  // Dental service settings
  getDentalServiceSettings: state => state.dentalServiceSettings,
  // Patient card settings
  getPatientCardSettings: state => state.patientCardSettings,
  // Treatment presentation settings
  getTreatmentPresentationSettings: state => state.treatmentPresentationSettings,
  // Lead settings
  getLeadSettings: state => state.leadSettings,
  // Online appointment settings
  getOnlineAppointmentSettings: state => state.onlineAppointmentSettings,
  // Warehouse settings
  getWarehouseSettings: state => state.warehouseSettings,
  // Print formats
  printFormats: state => state.printFormats,
}
